import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

import {
  Errors,
  LocalService,
  ManagerService,
  SellerService,
} from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { DataTableColumn } from 'src/app/shared/ui/data-table/data-table.component';

@Component({
  selector: 'app-activity-challenge-claims',
  templateUrl: './activity-challenge-claims.component.html',
  styleUrls: ['./activity-challenge-claims.component.scss'],
})
export class ActivityChallengeClaimsComponent implements OnInit, AfterViewInit {
  @ViewChild('actionTemplate') actionTemplate!: TemplateRef<any>;
  @ViewChild('dateTemplate') dateTemplate!: TemplateRef<any>;
  @ViewChild('netBookingsTemplate') netBookingsTemplate!: TemplateRef<any>;

  userProfile: any;
  companyClaiming: any = '';
  disableClaim = false;
  isGoldenTicketPartner: Boolean = false;
  nonTaggedUser: Boolean = false;

  searchData = '';
  size = 5;

  activityDealsToClaimed: any;
  activityTableColumns: DataTableColumn[] = [];
  activityPageNo = 0;
  activitySortBy: any;
  activitySearchName = '';
  isActivityTableLoading = false;

  claimEligibleDeal = false;
  claimNowBtnFlag = true;
  sellerDealId: any = '';
  spinnerBtnFlag = false;

  claimDisclaimerModalOpen = false;
  claimSuccessModalOpen = false;
  claimSuccessData: any = null;
  pendingClaimDealId: any = null;
  disclaimer: any = '';

  errors: Errors = { errors: {} };
  dataLoaded = false;

  constructor(
    private sellerService: SellerService,
    private managerService: ManagerService,
    private dialog: MatDialog,
    private popupMessageService: PopupMessageService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.isGoldenTicketPartner = this.userProfile.company.goldenTicketPartner;

    if (
      this.userProfile.pvieligible === false ||
      (this.userProfile.companyEligibleChallengesDTO &&
        this.userProfile.companyEligibleChallengesDTO.pvieligible === false)
    ) {
      this.disableClaim = true;
    }

    this.loadCompanyClaimingPreference();
    this.getActivityDealsToClaimed();
  }

  ngAfterViewInit() {
    this.initializeActivityTableColumns();
  }

  private loadCompanyClaimingPreference() {
    if (
      this.userProfile &&
      this.userProfile.company &&
      this.userProfile.company.id
    ) {
      const companyParams = { companyId: this.userProfile.company.id };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data: any) => {
          const companyClaim = data.companyPreferences.find(
            (item: any) => item.name === 'COMPANY_CLAIMING'
          );
          this.companyClaiming =
            companyClaim !== undefined ? companyClaim.enabled : false;
          this.dataLoaded = true;
        },
        (err: any) => {
          this.errors = err;
          this.dataLoaded = true;
        }
      );
    }
  }

  initializeActivityTableColumns(): void {
    this.activityTableColumns = [
      { field: 'customerName', header: this.translate.instant('manageClaims.manageTh5'), sortable: true, align: 'center', isBold: true },
      { field: 'poNumber', header: this.translate.instant('manageClaims.manageTh3') },
      {
        field: 'bookingDate',
        header: 'Booking Date',
        sortable: true,
        cellTemplate: this.dateTemplate,
        align: 'center'
      },
      {
        field: 'netBookings',
        header: this.translate.instant('manageClaims.manageTh6'),
        align: 'center',
        isBold: true,
        cellTemplate: this.netBookingsTemplate,
      },
      { field: 'quarter', header: this.translate.instant('manageClaims.manageTh8'), align: 'center' },
      {
        field: 'action',
        header: '',
        cellTemplate: this.actionTemplate,
        align: 'center'
      },
    ];
    this.cdr.markForCheck();
  }

  getActivityDealsToClaimed(activitySearch?: string) {
    this.isActivityTableLoading = true;
    const companyId = this.userProfile.company.id;
    const params: any = {
      page: this.activityPageNo,
      size: this.size,
    };
    if (this.activitySortBy) {
      params['sortBy'] = this.activitySortBy.active;
      params['sortDir'] = this.activitySortBy.direction;
    }
    if (activitySearch) {
      params['searchText'] = activitySearch;
    }
    this.sellerService.activityDealsToClaimed(companyId, params).subscribe(
      (data: any) => {
        this.activityDealsToClaimed = data;
        this.isActivityTableLoading = false;
      },
      (err: any) => {
        this.isActivityTableLoading = false;
        this.nonTaggedUser = true;
        this.errors = err;
      }
    );
  }

  getMoreActivityDealsToClaimed(pageNo: { pageIndex: number; pageSize: number }) {
    const companyId = this.userProfile.company.id;
    this.size = pageNo.pageSize;
    this.activityPageNo = pageNo.pageIndex;
    const params: any = {
      page: this.activityPageNo,
      size: this.size,
    };
    if (this.activitySortBy) {
      params['sortBy'] = this.activitySortBy.active;
      params['sortDir'] = this.activitySortBy.direction;
    }
    if (this.activitySearchName) {
      params['searchText'] = this.activitySearchName;
    }
    this.sellerService.activityDealsToClaimed(companyId, params).subscribe(
      (data: any) => {
        if (data.content) {
          this.activityDealsToClaimed.number = data.number;
          this.activityDealsToClaimed.content = data.content;
        }
      },
      (err: any) => {
        this.errors = err;
      }
    );
  }

  onActivityPageChange(page: number): void {
    this.activityPageNo = page - 1;
    this.getMoreActivityDealsToClaimed({
      pageIndex: this.activityPageNo,
      pageSize: this.size,
    });
  }

  onActivitySortChange(sortEvent: { sortBy: string; sortDir: string }): void {
    this.activitySortBy = {
      active: sortEvent.sortBy,
      direction: sortEvent.sortDir.toUpperCase(),
    };
    this.getActivityDealsToClaimed();
  }

  onResetFilters(): void {
    this.searchData = '';
    this.activitySearchName = '';
    this.activityPageNo = 0;
    this.activitySortBy = null;
    this.getActivityDealsToClaimed();
  }

  searchActivityByCustomerName(value: string, flag?: boolean) {
    if (!flag) {
      this.activitySearchName = value;
      if (value.length > 0) {
        this.activityPageNo = 0;
        this.getActivityDealsToClaimed(value);
      }
    }
    if (flag && value.length === 0) {
      this.activityPageNo = 0;
      this.activitySearchName = '';
      this.getActivityDealsToClaimed();
    }
  }

  getClaimTooltip() {
    return this.disableClaim
      ? "Claiming is disabled and you won't be able to earn rewards as minimum PVI requirement is not met."
      : '';
  }

  splitData(value: string) {
    const parseValue = parseFloat(value);
    const newData = parseValue.toLocaleString();
    return newData.toString();
  }

  async claimDeal(dealId: any) {
    this.sellerDealId = dealId;
    this.claimNowBtnFlag = false;
    this.spinnerBtnFlag = true;
    if (this.claimEligibleDeal !== false) {
      await this.geteligibledealsData(dealId);
    }

    this.disclaimer = '';
    this.dialog.closeAll();

    this.pendingClaimDealId = dealId;
    this.claimDisclaimerModalOpen = true;
  }

  onClaimDisclaimerConfirm(): void {
    this.claimDisclaimerModalOpen = false;
    this.claimNowBtnFlag = false;
    this.sellerService.claimDeal(this.pendingClaimDealId).subscribe(
      (data: any) => {
        this.sellerDealId = '';
        this.claimSuccessData = data;
        this.claimSuccessModalOpen = true;
        this.refreshAfterClaim();
        this.searchData = '';
      },
      (err: any) => {
        this.errors = err;
        this.claimNowBtnFlag = true;
        this.claimEligibleDeal = false;
        this.sellerDealId = '';
        if (err.message) {
          this.popupMessageService.showError(err.message, 'error');
        }
        if (
          err.status === '412 - PRECONDITION_FAILED' ||
          err.status === '409 - CONFLICT'
        ) {
          this.popupMessageService.showError(err.msg, 'error');
        }
      }
    );
  }

  private refreshAfterClaim() {
    this.activityPageNo = 0;
    this.activitySortBy = null;
    this.activitySearchName = '';
    this.getActivityDealsToClaimed();
  }

  closeClaimDisclaimerModal(): void {
    this.claimDisclaimerModalOpen = false;
    this.claimNowBtnFlag = true;
    this.sellerDealId = '';
  }

  closeClaimSuccessModal(): void {
    this.claimSuccessModalOpen = false;
    this.claimSuccessData = null;
  }

  trackByIndex(index: number): number {
    return index;
  }

  getUserInitial(name: string): string {
    if (!name) { return '?'; }
    return name.charAt(0).toUpperCase();
  }

  isUnclaimed(row: any): boolean {
    return !row || !row.claimedUsers || row.claimedUsers.length === 0;
  }

  hasPartialClaim(row: any): boolean {
    return row && row.claimedUsers && row.claimedUsers.length === 1;
  }

  isFullyClaimed(row: any): boolean {
    return row && row.claimedUsers && row.claimedUsers.length >= 2;
  }

  geteligibledealsData(dealId: any) {
    const promise = new Promise((resolve, reject) => {
      const reqParam: any = dealId + '?userId=' + this.userProfile.id;
      this.sellerService.getChallengeDetails(reqParam).subscribe(
        (response: any) => {
          if (response) {
            this.spinnerBtnFlag = false;
            if (response.eligibleChallenges.length > 0) {
              this.claimEligibleDeal = true;
            }
          }
          resolve(response);
        },
        (error: any) => {
          console.log(error);
        }
      );
    });
    return promise;
  }
}
